export function formatDateMDY(date: Date | string): string {
  const d = typeof date === 'string' ? parseDateMDY(date) : date;
  if (Number.isNaN(d.getTime())) return typeof date === 'string' ? date : '';
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${mm}/${dd}/${yyyy}`;
}

export function formatDateLong(date: Date | string): string {
  const d = typeof date === 'string' ? parseDateMDY(date) : date;
  if (Number.isNaN(d.getTime())) return '';
  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
  ];
  return `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
}

export function parseDateMDY(dateStr: string): Date {
  const parts = dateStr.trim().split('/');
  if (parts.length !== 3) return new Date(NaN);
  const [month, day, year] = parts.map((p) => parseInt(p, 10));
  if (!month || !day || !year) return new Date(NaN);
  const d = new Date(year, month - 1, day);
  if (d.getFullYear() !== year || d.getMonth() !== month - 1 || d.getDate() !== day) {
    return new Date(NaN);
  }
  return d;
}

export function isValidDateMDY(dateStr: string): boolean {
  return !Number.isNaN(parseDateMDY(dateStr).getTime());
}
